import {gql} from "apollo-angular";
import {basePageableGraphqlField, baseResponse, baseResponseGraphqlField} from "../../base.graphql";

export const feedbackFields = `
    id
    feedbackUniqueId
    feedbackType
    feedbackService {
      serviceUniqueId
      serviceName
      serviceProvider{
        id
          institutionUniqueId
          institutionName
          institutionShortform
      }
    }
    feedbackResponses
    feedbackResponded
    feedbackForwardedToEmrejesho
    feedbackComment
    feedbackCitizen {
      id
      userLastName
      userFirstName
    }
    feedbackCategory {
      id
      categoryName
      categoryUniqueId
    }
`

export const feedbackDataFields = `
id
      uniqueId
      title
      description
      suggestions
      country
      trackNumber
      feedbackType
      registeredToEmrejesho
      region {
        id
        regionalUniqueId
        reginalName
        reginalPostcode
        napaId
      }
      district {
        id
        districUniqueId
        districName
        districPostcode
        napaId
        districParentRegion {
          id
          regionalUniqueId
          reginalName
          reginalPostcode
          napaId
        }
      }
      ward {
        id
        wardUniqueId
        wardName
        wardPostcode
        napaId
        wardParentDistric {
          id
          districUniqueId
          districName
          districPostcode
          napaId
        }
      }
      street {
        id
        streetUniqueId
        streetName
        streetPostcode
        napaId
        streetParentWard {
          id
          wardUniqueId
          wardName
          wardPostcode
          napaId
        }
      }
      service {
        id
        serviceUniqueId
        serviceIsSubService
        serviceCode
        serviceName
        serviceIsApproved
        serviceDescription
        serviceHasSubService
        serviceHasCoProviders
        serviceCoProviders {
          id
          coproviderUniqueId
          coproviderCollaborationPurpose
          coproviderInstitution {
            id
            institutionUniqueId
            institutionName
            institutionShortform
            institutionPhysicalAddress
            institutionEmail
            institutionPostcode
            institutionWebsite
            institutionPhones
            institutionMapUrl
            institutionLogo
            institutionType
          }
        }
        serviceHasOpponents
        serviceGroups {
          id
          groupUniqueId
          groupType
        }
        serviceCategory {
          id
          categoryUniqueId
          categoryCode
          categoryName
          categoryDescription
        }
        serviceOpponents {
          id
          opponentUniqueId
          opponentInstitution {
            id
            institutionUniqueId
            institutionName
            institutionShortform
            institutionPhysicalAddress
            institutionEmail
            institutionPostcode
            institutionWebsite
            institutionPhones
            institutionMapUrl
            institutionLogo
            institutionType
          }
        }
        serviceResults {
          id
          resultUniqueId
          resultDescription
        }
        serviceProvider {
          id
          institutionUniqueId
          institutionName
          institutionShortform
          institutionPhysicalAddress
          institutionEmail
          institutionPostcode
          institutionWebsite
          institutionPhones
          institutionMapUrl
          institutionLogo
          institutionType
          institutionMinistry {
            id
            ministryUniqueId
            ministryName
          }
          institutionSector {
            id
            sectorUniqueId
            sectorCode
            sectorName
            sectorIcon
          }
          institutionRegion {
            id
            regionalUniqueId
            reginalName
            reginalPostcode
            napaId
          }
          institutionDistrict {
            id
            districUniqueId
            districName
            districPostcode
            napaId
          }
          institutionWard {
            id
            wardUniqueId
            wardName
            wardPostcode
            napaId
          }
          institutionStreet {
            id
            streetUniqueId
            streetName
            streetPostcode
            napaId
          }
          institutionFunctions {
            id
            functionUniqueId
            functionDutyName
            functionCreateddate
            functionIsActive
          }
        }
        serviceApprovalStage {
          id
          stageUniqueId
          stageName
          stageIsStarting
          stageIsEnding
          stageDesignation {
            id
            designationUniqueId
            designationShortForm
            designationName
          }
        }
        serviceForm {
          id
          hasForm
          formType
        }
        serviceFunctions {
          id
          uniqueId
          function {
            id
            functionUniqueId
            functionDutyName
            functionCreateddate
            functionIsActive
          }
        }
        serviceApprovalRemark
        serviceSentPopsmgg
        serviceIsRejected
      }
      feedbackComplaintEvidences {
        id
        uniqueId
        attachmentPath
        name
      }
      legalOpinions {
        id
        uniqueId
        library
        explaination
      }
      publicServantComplainant {
        id
        uniqueId
        firstName
        lastName
        phoneNo
        checkNo
        servantType
        designation
      }
      unregisteredComplainant {
        id
        uniqueId
        firstName
        lastName
        phoneNo
        gender
        age
      }
`

export const getServiceFeedbackComplaints = gql`
  query GetServiceFeedbackComplaints($filtering: FeedbackComplaintFilteringInputObject) {
    getServiceFeedbackComplaints(filtering: $filtering) {
     ${baseResponseGraphqlField}
      page {
        number
        hasNextPage
        hasPreviousPage
        nextPageNumber
        previousPageNumber
        numberOfPages
        totalItems
        pages
      }
      data {
        ${feedbackDataFields}
      }
    }
  }`

export const getMyServiceFeedbackComplaints = gql`
  query GetMyServiceFeedbackComplaints($filtering: FeedbackComplaintFilteringInputObject) {
    getMyServiceFeedbackComplaints(filtering: $filtering) {
      response {
        id
        status
        code
        message
      }
      page {
        number
        hasNextPage
        hasPreviousPage
        nextPageNumber
        previousPageNumber
        numberOfPages
        totalItems
        pages
      }
      data {
        id
        uniqueId
        title
        description
        suggestions
        country
        trackNumber
        feedbackType
        registeredToEmrejesho
        region {
          id
          regionalUniqueId
          reginalName
          reginalPostcode
          napaId
        }
        district {
          id
          districUniqueId
          districName
          districPostcode
          napaId
          districParentRegion {
            id
            regionalUniqueId
            reginalName
            reginalPostcode
            napaId
          }
        }
        ward {
          id
          wardUniqueId
          wardName
          wardPostcode
          napaId
          wardParentDistric {
            id
            districUniqueId
            districName
            districPostcode
            napaId
          }
        }
        street {
          id
          streetUniqueId
          streetName
          streetPostcode
          napaId
          streetParentWard {
            id
            wardUniqueId
            wardName
            wardPostcode
            napaId
          }
        }
        service {
          id
          serviceUniqueId
          serviceIsSubService
          serviceCode
          serviceName
          serviceIsApproved
          serviceDescription
          serviceHasSubService
          serviceHasCoProviders
          serviceCoProviders {
            id
            coproviderUniqueId
            coproviderCollaborationPurpose
            coproviderInstitution {
              id
              institutionUniqueId
              institutionName
              institutionShortform
              institutionPhysicalAddress
              institutionEmail
              institutionPostcode
              institutionWebsite
              institutionPhones
              institutionMapUrl
              institutionLogo
              institutionType
            }
          }
          serviceHasOpponents
          serviceGroups {
            id
            groupUniqueId
            groupType
          }
          serviceCategory {
            id
            categoryUniqueId
            categoryCode
            categoryName
            categoryDescription
          }
          serviceOpponents {
            id
            opponentUniqueId
            opponentInstitution {
              id
              institutionUniqueId
              institutionName
              institutionShortform
              institutionPhysicalAddress
              institutionEmail
              institutionPostcode
              institutionWebsite
              institutionPhones
              institutionMapUrl
              institutionLogo
              institutionType
            }
          }
          serviceResults {
            id
            resultUniqueId
            resultDescription
          }
          serviceProvider {
            id
            institutionUniqueId
            institutionName
            institutionShortform
            institutionPhysicalAddress
            institutionEmail
            institutionPostcode
            institutionWebsite
            institutionPhones
            institutionMapUrl
            institutionLogo
            institutionType
            institutionMinistry {
              id
              ministryUniqueId
              ministryName
            }
            institutionSector {
              id
              sectorUniqueId
              sectorCode
              sectorName
              sectorIcon
            }
            institutionRegion {
              id
              regionalUniqueId
              reginalName
              reginalPostcode
              napaId
            }
            institutionDistrict {
              id
              districUniqueId
              districName
              districPostcode
              napaId
            }
            institutionWard {
              id
              wardUniqueId
              wardName
              wardPostcode
              napaId
            }
            institutionStreet {
              id
              streetUniqueId
              streetName
              streetPostcode
              napaId
            }
            institutionFunctions {
              id
              functionUniqueId
              functionDutyName
              functionCreateddate
              functionIsActive
            }
          }
          serviceApprovalStage {
            id
            stageUniqueId
            stageName
            stageIsStarting
            stageIsEnding
            stageDesignation {
              id
              designationUniqueId
              designationShortForm
              designationName
            }
          }
          serviceForm {
            id
            hasForm
            formType
          }
          serviceFunctions {
            id
            uniqueId
            function {
              id
              functionUniqueId
              functionDutyName
              functionCreateddate
              functionIsActive
            }
          }
          serviceApprovalRemark
          serviceSentPopsmgg
          serviceIsRejected
        }
        feedbackComplaintEvidences {
          id
          uniqueId
          attachmentPath
          name
        }
        publicServantComplainant {
          id
          uniqueId
          firstName
          lastName
          phoneNo
          checkNo
          servantType
          designation
        }
        unregisteredComplainant {
          id
          uniqueId
          firstName
          lastName
          phoneNo
          gender
          age
        }
      }
    }
  }`

export const createFeedbackComplaint = gql`
  mutation CreateFeedbackComplaint($input: FeedbackComplaintInputObject!) {
    createFeedbackComplaint(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${feedbackDataFields}
      }
    }
  }`

export const CREATE_FEEDBACK = gql`
    mutation CreateFeedback($input: FeedbackInput!) {
        createFeedback(input: $input) {
            data {
                ${feedbackFields}
            }
            response {
                ${baseResponse}
            }

        }
    }
`;

export const TRANSFER_FEEDBACK_TO_EMREJESHO = gql`
    mutation TransferFeedbackToEmrejesho($input: TransferFeedbackInput!) {
        transferFeedbackToEmrejesho(input: $input) {
            response {
                ${baseResponse}
            }
            data{
                ${feedbackFields}
            }
        }
    }
`;

export const RESPOND_TO_SERVICE_FEEDBACK = gql`
    mutation RespondToServiceFeedback($input: FeedbackReponseInput!) {
        respondToServiceFeedback(input: $input) {
            data {
                ${feedbackFields}
            }
            response {
                ${baseResponse}
            }
        }
    }
`;

export const FEEDBACK_FOLLOWUP_FROM_EMREJESHO = gql`
    mutation FeedbackFollowupFromEmrejesho($feedbackUniqueId: String!) {
        feedbackFollowupFromEmrejesho(feedbackUniqueId: $feedbackUniqueId) {
            data {
                ${feedbackFields}
            }
            response {
                ${baseResponse}
            }
        }
    }
`;

